import { gql } from 'apollo-angular'

import { SUBSCRIPTION_WITH_PRICING_FIELDS } from './subscription-with-pricing.fragment'

export const ORGANIZATION_RESELLER_REQUEST_FIELDS = gql`
  fragment OrganizationResellerRequestFields on OrganizationResellerRequest {
    id
    name
    status
    createdAt
    updatedAt
    acceptedAt
    acceptedBy {
      id
      first_name
      last_name
      name
      email
    }
    requestedBy {
      id
      first_name
      last_name
      name
      email
    }
    requesterOrganization {
      id
      dh_id
      name
      streetName
      streetNumber
      postalCode
      city
      country
      invoiceEmail
      phone
      billingAdmins(limit: 1) {
        docs {
          id
          first_name
          last_name
          name
          email
        }
      }
    }
    resellerOrganization {
      id
      dh_id
      name
      streetName
      streetNumber
      postalCode
      city
      country
      invoiceEmail
      phone
      billingAdmins(limit: 1) {
        docs {
          id
          first_name
          last_name
          name
          email
        }
      }
    }
    subscriptions {
      id
      billingCycleFrequency
      billingCycleName
      nextInvoicingDate
      productName
      subscription {
        id
      }
    }
  }
`

export const ORGANIZATION_RESELLER_REQUEST_DETAIL_FIELDS = gql`
  fragment OrganizationResellerRequestDetailFields on OrganizationResellerRequest {
    ...OrganizationResellerRequestFields
    subscriptions {
      id
      billingCycleFrequency
      billingCycleName
      nextInvoicingDate
      productName
      subscription {
        ...SubscriptionWithPricingFields
      }
    }
  }
  ${ORGANIZATION_RESELLER_REQUEST_FIELDS}
  ${SUBSCRIPTION_WITH_PRICING_FIELDS}
`
